"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Box_1 = __importDefault(require("@material-ui/core/Box"));

var Add_1 = __importDefault(require("@material-ui/icons/Add"));

var Fab_1 = __importDefault(require("@material-ui/core/Fab"));

var ui_1 = require("../../ui");

var Footer = function Footer(props) {
  var _props$addUrl = props.addUrl,
      addUrl = _props$addUrl === void 0 ? '' : _props$addUrl,
      displayType = props.displayType,
      detailPage = props.detailPage,
      onAddClick = props.onAddClick;
  var addButton = detailPage === 'stack' ? react_1.default.createElement(Fab_1.default, {
    color: "primary",
    "aria-label": "add",
    size: "small",
    onClick: onAddClick
  }, react_1.default.createElement(Add_1.default, null)) : react_1.default.createElement(ui_1.AddButton, {
    onClick: addUrl
  });
  return react_1.default.createElement(Box_1.default, {
    pt: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, displayType !== 'view' && addButton);
};

exports.default = Footer;